import React from 'react'
import { FormattedMessage } from 'react-intl'
import messages from '../../../messages'
import { configContext } from '../Sirna'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Grid, Box } from '@material-ui/core'
import { Formik } from 'formik'

const useStyles = makeStyles((theme: Theme) => {
  return {
    lightGreyFont: {
      fontSize: theme.typography.pxToRem(15),
      '& .MuiGrid-spacing-xs-2': {
        paddingTop: theme.spacing(3.5),
      },
    },
    labelStylePerPage: {
      fontSize: theme.typography.pxToRem(15),
      paddingTop: theme.spacing(5.5),
      paddingLeft: theme.spacing(2),
      '& .MuiGrid-spacing-xs-2': {
        paddingTop: theme.spacing(3.5),
      },
    },
    labelStyleSortBy: {
      fontSize: theme.typography.pxToRem(15),
      paddingTop: theme.spacing(5.5),
      paddingLeft: theme.spacing(3),
      '& .MuiGrid-spacing-xs-2': {
        paddingTop: theme.spacing(3.5),
      },
    },
    valueStyle: {
      paddingTop: theme.spacing(3.5),
    },
    valueStylePerPage: {
      paddingTop: theme.spacing(3.5),
      paddingRight: theme.spacing(3.5),
    },
    paddingGrid: {
      padding: theme.spacing(3.5, 0, 3.5),
    },
    bgColor: {
      '& .MuiSelect-select': {
        border: 'none',
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
  }
})

const ResultSet = () => {
  const classes = useStyles()
  const { state } = React.useContext(configContext)
  const perPage =
    state.perPageCount === 'All'
      ? state.searchResult.count
      : parseInt(state.perPageCount)
  const totalCount = state.paginationData.totalCount
  const page = state.paginationData.page

  return (
    <>
      <Box>
        <Formik
          initialValues={{
            materialName: (
              <FormattedMessage
                {...messages.CONF_SPECIFICATION_PHYSICAL_MATERIAL_SYNTHETIC_RNA_crisprgrna}
              />
            ),
          }}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              actions.setSubmitting(false)
            }, 1000)
          }}
        >
          {() => (
            <>
              <Grid container className={classes.paddingGrid} direction="row">
                <Grid item xs={6} className={classes.lightGreyFont}>
                  <FormattedMessage
                    {...messages.SEMICONF_PAGINATION_SHOWING_TEXT_crisprgrna}
                  />{' '}
                  {totalCount > 0 ? (page - 1) * perPage + 1 : 0} -{' '}
                  {totalCount > page * perPage ? page * perPage : totalCount}{' '}
                  <FormattedMessage
                    {...messages.SEMICONF_PAGINATION_OF_TEXT_crisprgrna}
                  />{' '}
                  {totalCount}{' '}
                  <FormattedMessage
                    {...messages.SEMICONF_PAGINATION_RESULTS_TEXT_crisprgrna}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Formik>
      </Box>
    </>
  )
}

export default ResultSet
